import { useLocation } from "wouter";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { KnowledgeBaseManager } from "@/components/project/knowledge-base-manager";
import { useIsMobile } from "@/hooks/use-mobile";
import { DesktopOnlyNotice } from "./mobile/desktop-only-notice";

export default function KnowledgeBasePage() {
  const isMobile = useIsMobile();
  const [, navigate] = useLocation();
  if (isMobile) {
    return (
      <DesktopOnlyNotice
        title="Wissensdatenbank"
        description="Die Wissensdatenbank und Systemeinstellungen pflegst du am bequemsten am Computer. Bitte am Desktop öffnen."
      />
    );
  }
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-6xl mx-auto">
        <div className="mb-8 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <div>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">
              Wissensdatenbank & Einstellungen
            </h1>
            <p className="text-gray-600">
              Verwalten Sie Fachwissen, API-Keys und Systemeinstellungen für die KI-Analyse
            </p>
          </div>
          <Button
            variant="outline"
            onClick={() => navigate("/dashboard")}
            className="border-gray-300 text-gray-700 hover:bg-gray-50"
            data-testid="button-back-to-dashboard"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Zurück zum Dashboard
          </Button>
        </div>

        <KnowledgeBaseManager />
      </div>
    </div>
  );
}
